import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getLinkDownloadFileFromS3 } from '../common/FileUploaded';
import OverflowTooltipContent from '../common/OverflowTooltipContent';
import { PropTypes } from 'prop-types';
import './AttachFileChatPost.css';

function OtherAttachFile({ attachData, detailTicket }) {
    if (!attachData) return null;

    const fileData = {
        fileUrl: attachData.fileInfo.fileUrl,
        id: attachData.originId,
        content: attachData.fileInfo.fileName,
        type: Constant.S3_FILE_TYPE.TICKET_FILE
    };

    const downloadLink = getLinkDownloadFileFromS3(
        fileData,
        detailTicket,
        null,
        null,
        true // isLinkDownload = true for download link
    );

    return (
        <a
            href={downloadLink || '#'}
            target="_blank"
            rel="noopener noreferrer"
        >
            <OverflowTooltipContent
                text={`${attachData.fileInfo.fileName}(${Utils.formatBytes(attachData.fileInfo.fileSize)})`}
                className={'attach-file-chat-post-item-link'}
            ></OverflowTooltipContent>
        </a>
    );
}

OtherAttachFile.propTypes = {
    attachData: PropTypes.any,
    detailTicket: PropTypes.any
};

export default OtherAttachFile;

